export const getAPIUrl = appconfigKey => {
  let configKey = appconfigKey ? appconfigKey : "APPCONFIG";
  let APPCONFIGOBJ = window[configKey];
  let apiUrl = "api.timi91.com";
  if (
    (APPCONFIGOBJ && APPCONFIGOBJ.API_URL) ||
    (window[configKey] && window[configKey].API_URL)
  ) {
    apiUrl = window[configKey].API_URL;
  } else {
    let domain = window.location.host;
    let port = window.location.port;
    let domains = domain.split(".");
    if (domains && domains.length > 2) {
      domains[0] = "api";
      apiUrl = domains.join(".");
    }
    if (port) {
      apiUrl += ":" + port;
    }
    apiUrl = "http://" + apiUrl + "/";
  }
  return apiUrl;
};



// WEBPACK FOOTER //
// ./src/config/util.js